import VuexTypes from '@/store/types/index';

const InvoicesAdvanceTypes = VuexTypes.invoicesAdvance;
export default {
  [InvoicesAdvanceTypes.ADV_INVOICES_LIST]: (state, { data, status }) => {
    state.advanceInvoicesList = { data, status };
  },
  [InvoicesAdvanceTypes.ADV_INVOICES_LIST_FILTERS]: (state, { data, status }) => {
    state.advanceInvoicesListFilters = { data, status };
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_CLASSIFIERS]: (state, { data, status }) => {
    state.advanceInvoiceClassifiers = { data, status };
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_UPDATE_DATA]: (state, { data, status }) => {
    state.advanceInvoiceUpdateData = { data, status };
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_MEDIA_LIST]: (state, { data, status }) => {
    state.advanceInvoiceMediaList = { data, status };
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_CREATE]: (state, { data, status }) => {
    state.advanceInvoiceCreate = { data, status };
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_UPDATE]: (state, { data, status }) => {
    state.advanceInvoiceUpdate = { data, status };
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_DELETE_ATTACHMENT]: (state, { data, status }) => {
    state.advanceInvoiceDeleteAttachment = { data, status };
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_UPDATE_STATUS]: (state, { data, status }) => {
    state.advanceInvoiceUpdateStatus = { data, status };
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_PAYMENT_APPROVE]: (state, { data, status }) => {
    state.advanceInvoicePaymentApprove = { data, status };
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_PAYMENT_REJECT]: (state, { data, status }) => {
    state.advanceInvoicePaymentReject = { data, status };
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_ACTIVITY]: (state, { data, status }) => {
    state.advanceInvoiceActivity = { data, status };
  },
  [InvoicesAdvanceTypes.ADV_INVOICE_DELETE]: (state, { data, status }) => {
    state.advanceInvoiceDelete = { data, status };
  },
  [InvoicesAdvanceTypes.UPDATE_NEW_ADV_INVOICE_FILES]: (state, data) => {
    state.newAdvanceInvoiceFiles = data;
  },
};
